import { render, staticRenderFns } from "./recommendHouse.vue?vue&type=template&id=403b2e4e&scoped=true"
import script from "./recommendHouse.vue?vue&type=script&lang=js"
export * from "./recommendHouse.vue?vue&type=script&lang=js"
import style0 from "./recommendHouse.vue?vue&type=style&index=0&id=403b2e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403b2e4e",
  null
  
)

export default component.exports